module.exports = __webpack_public_path__ + "static/media/side2.e5b3e81d.png";